import classNames from "classnames";
import React, { FC } from "react";

export interface IconProps {
    theme?: string | { svg: string };
    size?: number | string;
    color?: string;
    style?: React.CSSProperties;
    viewBox?: string;
    icon: JSX.Element;
}

const defaultProps: IconProps = {
    color: "#000000",
    icon: <path d="" />,
    size: 18,
    viewBox: "0 0 100 100"
};

/**
 * A simple SVG Icon
 *
 * Help from https://medium.com/@david.gilbertson/icons-as-react-components-de3e33cb8792
 * @param props
 */
export const Icon: FC<IconProps> = props => {
    props = { ...defaultProps, ...props };

    const realSize = typeof props.size === "number" ? props.size + "px" : props.size;

    const className = typeof props.theme === "object" ? props.theme.svg : props.theme;
    return (
        <svg
            className={classNames(className)}
            style={props.style}
            width={realSize}
            height={realSize}
            viewBox={props.viewBox}
            fill={props.color}
        >
            {props.icon}
        </svg>
    );
};
